<template>

	<!-- COMPONENTE DE CADASTRO INICIO -->
    <ApolicesForm
      :open= "apolicesFormOpen"
      @update-open= "apolicesFormOpen = false"
      :inputsList="inputs"
      :title= "headerInfo.title"
      @data= "onSendFormData"
      :resetFormData= "resetFormData"
    />

	<Commonlisting
		:listingData = "data"
		:headersData = "headers"
		:headerInfo = "headerInfo"
		:inputsListing= "inputs"
		:previous = "previous"
		:next = "next"
		:fileOnly="false"
		:currentPage = "currentPage"
		:totalPages = "totalPages"
		:totalRecords = "totalRecords"
		:editFormData= "editFormData"
		:importFile= "false"
		:useForms= "false"
		:resetFormData= "resetFormData"
		@previous-page= "pageData"
		@next-page= "pageData"
		@go-to-page= "goTo"
		@find-by-field= "filtered"
		@new-alternative="apolicesFormOpen = true"
		@clean-filter= "cleanFilter"
		@delete-data-id= "deleteData"
		@edit-alternative= "getEditData"
	/>
</template>
<script>

import Commonlisting from '@/components/generalcomponents/CommonListing';
import ApolicesRepository from '@/services/ApolicesRepository.vue';
import { pageVariables } from '@/views/insideviews/apolices/PageVariablesApolices';
import { handleUnauthorized } from '@/services/AuthSer/authServiceFunction';
import ApolicesForm from './ApolicesForm.vue';

export default {
	name: 'ApolicesView',
	async created(){
		this.onlineUser = JSON.parse(window.localStorage.getItem("myUser") || "{}");
		this.pageData(this.page)
	},
	data() {
		return {
			...pageVariables,
			data: [],
			previous: '',
			next: '',
			totalPages: 0,
			totalRecords: 0,
			currentPage: 0,
			resetFormData: false,
			editFormData:{},
			onlineUser: JSON.parse(window.localStorage.getItem("myUser")),
			apolicesFormOpen: false
		};
	},
	props: {
	},
	methods: {
		async pageData(page){
			this.loading = true; 
			const apolicesRepo = new ApolicesRepository();
			try {
				const response = await apolicesRepo.getApolices(this.onlineUser.token,page);
				if (response?.status  === 200) {
					this.data = response.data.data;
					this.totalPages = response.data.last_page;
					this.totalRecords = response.data.total;
					this.currentPage = response.data.current_page;

				if (response.data.next_page_url) {
					this.next = response.data.next_page_url;
				}else{
					this.next = ""
				}
				if (response.data.prev_page_url) {

					this.previous = response.data.prev_page_url;
				}else{
					this.previous = ""
				}
				this.loading = false; 

				}
			} catch (error) {
				this.loading = false; 
				handleUnauthorized(error); 
			}
		},
		async onSendFormData(data){
			const apolicesRepo = new ApolicesRepository();
			try {
				console.log(data)
				const response = await apolicesRepo.createApolice(this.page,data,this.onlineUser.token);
				if (response?.status === 201) {
					this.pageData(this.page);
					this.resetForm();
				} else {
					this.error = response?.message;
				}
			} catch (error) {
				handleUnauthorized(error); 
			}	
		},
		async onSendEditingData(data,id){
			const apolicesRepo = new ApolicesRepository();
			try {
				console.log(data)
				const response = await apolicesRepo.updateApolice(this.page,this.onlineUser.token,id,data);
				if (response?.status === 200) {
					this.pageData(this.page);
				} else {
					this.error = response?.message;
				}
			} catch (error) {
				handleUnauthorized(error); 
			}	
		},
		async deleteData(id){
			const apolicesRepo = new ApolicesRepository();
			try {
				const response = await apolicesRepo.deleteApolice(this.page,this.onlineUser.token,id);
				if (response?.status === 204) {
					this.pageData(this.page);

				} else {
					this.error = response?.message;
				}
			} catch (error) {
				handleUnauthorized(error); 
			}	
		},
		async getEditData(id){
			console.log(id)
			const apolicesRepo = new ApolicesRepository();
			try {
				const response = await apolicesRepo.getApolice(this.page,this.onlineUser.token,id);
				if (response?.status === 200) {
					console.log(response)
					this.editFormData = response.data
				} else {
					this.error = response?.message;
				}
			} catch (error) {
				handleUnauthorized(error); 
			}	
		},
		goTo(number){
			this.pageData(this.page+"?page="+number)
		},
		filtered(filteredData){
			const key = this.seachFilterKey;
			const value = filteredData;
			if (key) {
				this.pageData(this.page+"?"+key+'='+value);
			}
		},
		cleanFilter(){
		this.pageData(this.page)	
		},
		
		resetForm() {
			this.resetFormData = true;
			this.$nextTick(() => {
				this.resetFormData = false;
			});
		}
	},
	components:{
		Commonlisting,
		ApolicesForm
	},
	setup() {
	return {
	}
	}}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
